<template>
  <CustomTextField
    v-model="password"
    :append-icon="appendIcon"
    :rules="rules"
    :type="type"
    :label="label"
    :prepend-icon="prependIcon"
    v-bind="$attrs"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    @click:append="show = !show"
    v-on="$listeners"
    :data-test="dataTest"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: "PasswordField",
  props: {
    label: {
      type: String,
      default: "Пароль",
    },
    rules: {
      type: Array,
      default: () => [(value) => !!value || "Пароль не може бути пустим"],
    },
    prependIcon: {
      type: String,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
    dataTest: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    show: false,
    password: "",
  }),
  computed: {
    appendIcon() {
      return this.show ? "mdi-eye" : "mdi-eye-off";
    },
    type() {
      return this.show ? "text" : "password";
    },
  },
};
</script>
